import Vue from 'vue';
import Log from 'cgil-log';

export const VERSION = '1.1.1';
export const BUILD_DATE = '19-07-2024';
export const DEV = process.env.NODE_ENV === 'development';
export const DEFAULT_BASE_SERVER_URL = DEV ? 'https://chantier.lausanne.ch/api' : '/api';
export const getLog = (ModuleName, verbosityDev, verbosityProd) =>
  ((DEV) ? new Log(ModuleName, verbosityDev) : new Log(ModuleName, verbosityProd));

export const LAUSANNE_OFSID = 5586;

export const BASE_PATH = DEV ? '' : '';

export const BASE_REST_API_URL = DEV ? 'https://chantier.lausanne.ch/api/geo/' : '/api/geo/';
export const geoJSONUrl = DEV ? 'https://chantier.lausanne.ch/api/chantiers' : '/api/chantiers/';

export const bus = new Vue();
